module.exports = __webpack_public_path__ + "cd3081f7a6be2eea73652a35be98cb3c.png";